import baseUrl from "../config/baseUrl";

const pdfBase64Data = async (token, id, document_table) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/sample_blob_data?document_id=${id}&document_table=${document_table}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.json();
  } catch (error) {
    return error;
  }
};

export default pdfBase64Data;
